import React, {useState, useEffect, useRef} from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import ptLocale from '@fullcalendar/core/locales/pt-br';
import ApiService from "../util/ApiService";
import DutyDetailModal from "./calender/dutyDetailModal";
import PlantaoModal from "./calender/plantaoModal";
import './assets/css/FullCalendar.css';
import PlantaoRepostModal from "./calender/plantaoRepostModal";
import DudyListDesboard from "./DutyList";
import "font-awesome/css/font-awesome.min.css";
const FullCalendarHome = (props) => {

    const [loading, setLoading] = useState(false);
    const [events, setEvents] = useState([]);
    const [duty, setDuty] = useState([]);
    const [duties, setDuties] = useState([]);
    const [selectedEventDetails, setSelectedEventDetails] = useState(null);
    const [currentDate, setCurrentDate] = useState(
        new Date().toLocaleDateString('pt-BR').split('/').reverse().join('-')
    );


    const [showEventModal, setShowEventModal] = useState(false);
    const [showPlantaoModal, setShowPlantaoModal] = useState(false);
    const [showPlantaoRepostModal, setShowPlantaoRepostModal] = useState(false);

    const [filters, setFilters] = useState({
        user_id: "",
        hospital: "",
        duty_scale_day_wee_id: "",
        order_month: "",
        department_id: "",
    });

    const calendarRef = useRef(null);
    const lastFetchedRange = useRef({startStr: '', endStr: ''}); // Armazena o intervalo anterior

    useEffect(() => {
        if (calendarRef.current) {
            const calendarApi = calendarRef.current.getApi();
            const {startStr, endStr} = getCurrentDateRange(calendarApi);
            fetchEventsIfNeeded(startStr, endStr); // Verifica e busca eventos apenas se necessário
        }
    }, [calendarRef.current]);

    const getCurrentDateRange = (calendarApi) => {
        const view = calendarApi.view;
        return {
            startStr: view.activeStart.toISOString().split('T')[0],
            endStr: view.activeEnd.toISOString().split('T')[0],
        };
    };

    const getMonthRangeFromCalendar = () => {
        const calendarApi = calendarRef.current?.getApi();
        if (!calendarApi) return null;

        const currentDate = calendarApi.getDate(); // Data central da view atual
        const year = currentDate.getFullYear();
        const month = currentDate.getMonth(); // de 0 a 11

        const start = new Date(year, month, 1);
        const end = new Date(year, month + 1, 0); // Último dia do mês

        const format = (date) => date.toISOString().split('T')[0];

        return {
            startStr: format(start),
            endStr: format(end),
        };
    };



    const fetchEvents = (datestart, dateend) => {
        ApiService.send('post', `${process.env.REACT_APP_URL_API}duty/duty-record`,
            {
                datestart: datestart,
                dateend: dateend,
                hospital: filters.hospital_id,
                user: filters.user_id,
                per_page: 1000,
                allCompany: true,
                department: filters.department_id
            },
            true
        ).then((response) => {
            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);

            if (data) {
                setDuties(data);
                const eventData = data.map((event) => ({
                    title: event.hospital.name || "Sem Nome",
                    start: event.date_time,
                    end: event.date_time_end,
                    id: event?.id,
                    extendedProps: {...event},
                }));
                setEvents(eventData || []);
            }

        }).catch((error) => {
            console.error('Error fetching calendar data:', error);
        });
    };

    const fetchEventsIfNeeded = (startStr, endStr) => {
        if (startStr !== lastFetchedRange.current.startStr || endStr !== lastFetchedRange.current.endStr) {
            lastFetchedRange.current = {startStr, endStr};
            fetchEvents(startStr, endStr);
        }
    };

    const handleDatesSet = (dateInfo) => {
        if (calendarRef.current) {
            const calendarApi = calendarRef.current.getApi();
            const {startStr, endStr} = getCurrentDateRange(calendarApi);
            fetchEventsIfNeeded(startStr, endStr); // Chama apenas se o intervalo mudou
        }
    };

    const handleEventClick = (clickInfo) => {
        setSelectedEventDetails(clickInfo.event.extendedProps);
        setShowEventModal(true);
    };


    const handlePlantaoModalClose = () => {
        setShowPlantaoModal(false);
    };
    const handlePlantaoRepostModalClose = () => {
        setShowPlantaoRepostModal(false);
    };


    const handleDateSelect = (selectInfo) => {
        const start = selectInfo.startStr;
        setCurrentDate(start);
    };




    return (

        <>

            <DudyListDesboard duties={duties} currentDate={currentDate}/>
            <div className="col-md-8 col-lg-8">
                <div className="card card-table">
                <div className="card-body">
                        <div id="morrisLine"/>
                        <div className="col-md-12 mt-2">
                            <FullCalendar
                                ref={calendarRef}
                                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                headerToolbar={{
                                    left: "prev",
                                    center: "title",
                                    right: "next",
                                }}

                                initialView="dayGridMonth"

                                editable={false}
                                selectable={true}
                                selectMirror={true}
                                dayMaxEvents={true}
                                events={events}
                                locales={[ptLocale]}
                                eventClick={handleEventClick}
                                datesSet={handleDatesSet}
                                select={handleDateSelect}
                                fixedWeekCount={true}
                                eventClassNames="custom-event"
                            />
                        </div>
                    </div>
                </div>

                {/* Modal de detalhes do evento */}
                {showEventModal && (
                    <DutyDetailModal
                        show={showEventModal}
                        handleClose={() => setShowEventModal(false)}
                        eventDetails={selectedEventDetails}
                        onRepost={(event) => {
                            setShowEventModal(false);
                            setDuty(event);
                            setShowPlantaoRepostModal(true);
                        }}
                        onEdit={(event) => {
                            setShowEventModal(false);
                            setDuty(event);
                            setShowPlantaoModal(true);
                        }}
                    />
                )}

                {/* Modal de cadastro de plantão */}
                {showPlantaoModal && (
                    <PlantaoModal
                        show={showPlantaoModal}
                        handleClose={handlePlantaoModalClose}
                        duty={duty}
                    />
                )}

                {showPlantaoRepostModal && (
                    <PlantaoRepostModal
                        show={showPlantaoRepostModal}
                        handleClose={handlePlantaoRepostModalClose}
                        duty={duty}
                    />
                )}
            </div>
        </>
    );
};

export default FullCalendarHome;
